export const typeOfBusinessSelected = [
  { value: 1, type: "税理士・会計事務所" },
  { value: 2, type: "中小企業診断士" },
  { value: 3, type: "その他士業" },
  { value: 4, type: "金融機関" },
  { value: 5, type: "一般企業（金融機関以外）" },
  { value: 6, type: "その他" },
];
